module.exports = __webpack_public_path__ + "static/16-thumb-614273e7e0a2e70dbbb113fd7a5dc11a.jpg";